/**
 * Pretty-printed JSON viewer — Faz 8.1.
 *
 * Stable, deterministic rendering: keys are alphabetically sorted at
 * every depth so visually identical inputs always render identically
 * (matters for the replay golden-hash + visual diff workflow).
 */

const stringify = (v: unknown): string => {
  return JSON.stringify(
    v,
    (_, value) => {
      if (typeof value === "bigint") return value.toString();
      if (value !== null && typeof value === "object" && !Array.isArray(value)) {
        const sorted: Record<string, unknown> = {};
        for (const k of Object.keys(value as Record<string, unknown>).sort()) {
          sorted[k] = (value as Record<string, unknown>)[k];
        }
        return sorted;
      }
      return value;
    },
    2,
  );
};

import type { ReactElement } from "react";

export interface JsonTreeProps {
  readonly value: unknown;
  readonly className?: string;
}

export const JsonTree = ({ value, className }: JsonTreeProps): ReactElement => (
  <pre
    data-testid="json-tree"
    className={`overflow-auto rounded border border-slate-800 bg-slate-950 p-3 text-xs font-mono text-slate-200 ${
      className ?? ""
    }`}
  >
    {stringify(value)}
  </pre>
);
